import { createSelector } from 'reselect';

const bookingState = state => state.get('booking-page');

export const makeSelectBooking = () =>
  createSelector(bookingState, state => {
    let booking = state.getIn(['booking']);
    return booking ? booking.toJS() : null;
  });

export const getBooking = state =>
  state.getIn(['booking-page', 'booking'])

export const getBookingChanged = () =>
  createSelector(bookingState, state => state.getIn(['bookingChanged']));

export const getBookingUuid = state =>
  state.getIn(['booking-page', 'booking', 'bookingUuid'])
export const getAuthUserSelector = state =>
  state.getIn(['booking-page', 'authUser'])

export const getLoading = () =>
  createSelector(bookingState, state => state.getIn(['loading']));

export const getBookingReloading = () =>
  createSelector(bookingState, state => state.getIn(['bookingReloading']));

export const getAuthUser = () =>
  createSelector(bookingState, state => state.get('authUser'))
